module.exports = __webpack_public_path__ + "media/about/lina-xing-c701af0d.jpg";